import { Error, RootState } from '@/store/types';
import axios, { AxiosError, AxiosResponse, AxiosPromise } from 'axios';
import { ActionTree } from 'vuex';
import { Firmware, FirmwareState } from './types';

/**
 *
 *
 * @param {*} commit
 * @returns {(Promise<void | AxiosResponse<any>>)}
 */
function getFirmwares(commit: any): Promise<void | AxiosResponse<any>> {
  return axios({
    url: '/api/v1/firmwares',
  }).then(
    (response: AxiosResponse) => {
      const payload: Firmware = response && response.data;
      commit('GET_SUCCESS', payload);
      return response;
    },
    (error: AxiosError) => {
      const payload: Error = new Error(error);
      commit('GET_ERROR', payload);
    },
  );
}

export const actions: ActionTree<FirmwareState, RootState> = {
  /**
   *
   *
   * @param {*} { commit }
   * @returns {*}
   */
  getFirmwares({ commit }): any {
    return getFirmwares(commit);
  },

  /**
   *
   *
   * @param {*} { commit, state }
   * @param {*} { file, type }
   * @returns {*}
   */
  uploadFirmware({ commit, state }, { file, type }): any {
    const formData: FormData = new FormData();
    formData.append('file', file[0].files[0]);
    axios({
      url: `/api/v1/firmwares/${type}`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      method: 'PUT',
      data: formData,
    })
      .then((response: AxiosResponse) => {
        return getFirmwares(commit);
      })
      .then(
        (response: AxiosResponse) => {
          commit('UPLOAD_FIRMWARE_SUCCESS');
        },
        (error: AxiosError) => {
          const payload: Error = new Error(error);
          commit('UPLOAD_FIRMWARE_ERROR', payload);
        },
      );
  },
};
